export const updateUserSuccess = (message) => `Successfully updated agent: ${message}!`;
export const errorUpdatingUser = (message) => `Error updating agent: ${message}`;
